import { GridFlex, Icon, Text, useSupportChat } from '@stigg-components';
import { t } from 'i18next';

export function SsoContactUs() {
  const { showNewMessage } = useSupportChat();

  const handleContactUsClick = () => {
    showNewMessage(t('accounts.loginOptions.accessMethod.options.SSO.contactUs.supportChatPrefilledMessage'));
  };

  return (
    <>
      <GridFlex.RowCenter>
        <GridFlex.Column marginRight={2}>
          <Icon icon={'Info'} color={'primary.main'} style={{ margin: 'auto' }}></Icon>
        </GridFlex.Column>
        <GridFlex.Column>
          <Text.B2 color={'primary.main'} onClick={handleContactUsClick} mr={1}>
            {t('accounts.loginOptions.accessMethod.options.SSO.contactUs.buttonText')}
          </Text.B2>
        </GridFlex.Column>
        <GridFlex.Column>
          <Text.B2>{t('accounts.loginOptions.accessMethod.options.SSO.contactUs.content')}</Text.B2>
        </GridFlex.Column>
      </GridFlex.RowCenter>
    </>
  );
}
